import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import visible from './modules/visible.js'
import common from './modules/common.js'
import preWorkInfo from './modules/preWorkInfo';

import datavMap from './modules/datavMap.js'//TODO: 地图大屏

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    visible,
    common,
    datavMap,
    preWorkInfo
  }
});
export default store;
